<template>
  <div v-loading="loading" v-if="componentIsActive">
    <el-card v-fill-height="5" class="routes">
      <div slot="header" class="clearfix">
        <s-form-actions :responsive="true" :drawer-width="200">
          <div slot="left">
            <el-checkbox

                v-model="incluedCanceled"
                border
                title="Include canceled bookings"
            >
              <i class="material-icons">block</i>
            </el-checkbox>

          </div>
          <ctk-dater
              slot="left"
              xstyle="width:220px"
              range

              v-model="timelineRange"
              display-format="dd/MM/yyyy"
              export-format="DD/MM/YYYY"
              default="2months"
          ></ctk-dater>
          <div slot="left">
            <q-input v-model="searchBkRoute" style="margin-left: 1%" dense label="Search" color="white" clearable
                     label-color="orange">
              <template v-slot:append>
                <q-icon name="search" style="color:#FFF"/>
              </template>
            </q-input>
          </div>
          <div slot="middle">
            <q-btn-toggle
                v-model="dayView"
                class="my-custom-toggle"
                no-caps
                rounded
                unelevated
                toggle-color="green"
                color="white"
                text-color="green"
                :options="[      {icon: 'line_style', value: 'timeline'},
                    {icon: 'table_chart', value: 'table'},
          {icon: 'call_merge', value: 'vertical_timeline'},
   // {icon: 'download', value: 'download'},
        ]"
            />
            <q-btn icon="download" @click="$refs.timeline_routes.download()"></q-btn>
            <!--            <sf-button type="warning" style="float:right" @click="dayView=!dayView">-->
            <!--              <span class="material-icons">{{ dayView ? 'call_merge' : 'line_style' }}</span>-->
            <!--            </sf-button>-->
          </div>
          <s-select
              style="width: 100px;"
              options-repo="vehicleTypes"
              v-model="wVehicleGroup"
              label-prop="type"
              value-prop="type"

          ></s-select>
          <div>
            <!--            <div slot="left" style="width: 120px">-->

            <!--            </div>-->
            <sf-button
                style="float:right"
                @click="routeGo({name:'transferBooking',params:{transferBookingId:'new',vehicleGroup:wVehicleGroup}})"
            >+
              <fa
                  icon="car"
                  fixed-width
                  size="lg"></fa>
            </sf-button>
          </div>
        </s-form-actions>
      </div>

      <s-timeline
          :key="clock"
          :dayView="dayView"
          v-fill-height="5"
          v-if="servicesQuery"
          ref="timeline_routes"
          modx-processor="vue_route/getlist"
          :time-query="servicesQuery"
          time-range-prop="timerange"
          group-prop="asset_id"
          :super-group-aggregator="avaialbilityFactory"
          superGroupProp="type"
          :group-end-point="getPossibleVehicles"
          :group-renderer="groupRenderer"
          :time-asset-renderer="timeAssetRenderer"
          @timeline-clicked="handleNewRent"
          @event-clicked="routeGo({name:'transferBooking',params:{transferBookingId:$event.bk_id,vehicleGroup:wVehicleGroup}})"
      ></s-timeline>
    </el-card>
    <el-drawer
        :with-header="false"
        append-to-body
        :size="rightDrawerSize()"
        :visible.sync="showRightModal"
        direction="rtl"
        @close="routeGo({name:'timelineForProducts',params:{transferBookingId:null}});"
    >
      <router-view xdone="handleDone" @done="refreshTimeline"></router-view>
    </el-drawer>
  </div>
</template>

<script>
import * as api from "~/api/resource";
import moment from "moment";

import {mapGetters, mapActions} from "vuex";
// import { async } from "q";
import commons from "~/mixins/commons";

export default {
  name: 'RoutesTimeline',
  mixins: [commons],
  async mounted() {
    if (!this.timelineRange)
      this.timelineRange = [moment().startOf('week').format("DD/MM/YYYY"), moment().endOf('year').format('DD/MM/YYYY')]
    // var vm = this;
    // this.autoUpdate = ["workingTrip"]; //commons
    this.loading = false;
    // _log_("the USERRRR../", this.loggedUser);
  },
  props: {
    viewmode: {
      type: String,
      default: "simple"
    }
  },
  watch: {
    "$route.params.vehicleGroup": {
      handler(v, vo) {
        _log_("$route.params.transferBookingId.11...", vo, this.$route.params, this.$route.query);
        if (v == vo) return
        if (!this.timelineRange)
          this.timelineRange = [moment().startOf('week').format('DD/MM/YYYY'), moment().endOf('year').format('DD/MM/YYYY')]
      }, deep: true
    },
    "$route.params.transferBookingId": {
      handler: async function (transferBookingId, old_transferBookingId) {

        if (this.$route.name != "transferBooking") {
          this.showRightModal = false;
          return;
        }
        //
        // if (this.$route.name != "timologio") return;
        if (!transferBookingId || transferBookingId == old_transferBookingId)
          return;
        this.showRightModal = true;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    refreshTimeline(lastBk) {
      // ++this.clock
      // _log_("the refreshTimeline../", lastBk);
      this.focusOn = lastBk.id
    },
    async getPossibleVehicles(q) {


      return await this.getVehicles(q.vehicleGroup || 'all');
    },
    handleNewRent(e) {
      _log_("the handleNewRent../", e.time);

      this.routeGo({
        name: "transferBooking",
        params: {transferBookingId: "new", vehicleGroup: this.wVehicleGroup},
        query: {initialTime: e.time.getTime(), selected_asset: e.group.id}
      });
    },
    avaialbilityFactory(groupAssets, timeAssets) {
      const daySize = 24 * 3600000;
      var availabilityMap = {},
          models = {};
      groupAssets.forEach(v => {
        models[v.id] = v.model ? v.model : "N/A";
      });
      // _log_("s000ka/avaialbilityFactory//..", models);
      timeAssets.forEach(tA => {
        const startsOn = Math.floor(tA.start / daySize) * daySize,
            endsOn = Math.floor(tA.end / daySize) * daySize;
        for (let index = startsOn; index <= endsOn; index += daySize) {
          if (tA.pax) {
            const supper_key = models[tA.asset_id];

            if (!availabilityMap[supper_key]) availabilityMap[supper_key] = {};
            availabilityMap[supper_key][index] = availabilityMap[supper_key][
                index
                ]
                ? availabilityMap[supper_key][index] + tA.pax
                : tA.pax;
          }
        }
      });
      var superAssets = [],
          iday = 0;
      // _log_("skkkaka/avaialbilityFactory//..", availabilityMap);
      for (var [groupkey, assets] of Object.entries(availabilityMap))
        for (var [day, pax] of Object.entries(assets)) {
          if (day) {
            // _log_("GGGlityFactory//..", day, groupkey);
            const cgroupkey = groupkey + "";
            superAssets.push({
              content: pax + "",
              type: "point",
              group: cgroupkey,
              start: parseInt(day),
              // end: parseInt(day) + 3600000,
              id: ++iday + "_super"
            });
          }
        }
      // _log_("skkkaka///..", superAssets);
      return superAssets;
    },
    timeAssetRenderer(data) {
      // return 'aaaaa'
      let out = [],
          classes = "";
      if (data.depts <= 0) classes += "payments-un";
      else if (data.pays >= data.depts) classes += "payments-done";
      else if (data.pays <= 0) classes += "payments-none";
      else classes += "payments-some";
      out.push(data.pupnameA || '');
      out.push('<span class="material-icons">query_builder</span>');
      out.push(data.startTimeHuman);
      out.push('<span class="material-icons">play_arrow</span>');
      if (data.pupnameA != data.pupnameZ && data.pupnameZ) out.push('<span style="float:right">' + data.pupnameZ + '</span>');
      out.push('<span class="material-icons">query_builder</span>');
      out.push('<span>' + data.endTimeHuman + "</span>");
      return `<div class="${classes}">${out.join('')}</div>`;
      // return (
      //   data.pax +
      //   " bookings from " +
      //   data.bk_id +
      //   " on " +
      //   this.formatUnxTime(data.trip_time, false, true)
      // );
    },
    groupRenderer(data) {
      return data.vgroup + ' : ' + data.name + ' (' + data.model + ')';
    },

    async getProducts() {
      return api.getModxList("pricerules", {
        mode: "select",
        context: "sapplier",
        // connect: "bookings",
        // sum: "pax",
        productid: this.$route.query.tripselect,
        timerange: this.timelineRange, //this.$route.timerange,
        limit: 0
      });
    },
    async clickHandler(val) {
    }
  },
  data() {
    return {
      vehicleGroups: ["Car", "Scouter", "QuadBike", "Boat"],
      // wVehicleGroup: "Car",
      showRightModal: false,
      loading: true,
      searchBkRoute: null,
      focusOn: null,
      // dayView: 'timeline',
      incluedCanceled: false,
      errors: {},
      clock: 0
    };
  },
  computed: {
    dayView: {
      set(v) {

        this.routeGo({query: {dayView: v || 'timeline'}});
        // this.$router.replace({ params: { vehicleGroup: v } });
      },
      get() {
        return this.$route.query.dayView || 'timeline';
      }
    },
    componentIsActive() {
      return (
          this.$route.name == "timelineForProducts" ||
          this.$route.name == "transferBooking"
      );
    },
    timelineRange: {
      set(v) {
        // if (this.loading) return;
        let q = JSON.parse(JSON.stringify(this.$route.query));
        if (!v) {
          delete q.timerange_from;
          delete q.timerange_to;
        } else {
          if (v[0]) q.timerange_from = v[0];
          if (v[1]) q.timerange_to = v[1];
          else delete q.timerange_to;
        }
        // _log_("new route q ", q);
        this.routeGo(
            {
              query: q
            },
            true
        );
        // this.$router
        //   .push({
        //     query: q,
        //     params: this.$route.params,
        //     name: this.$route.name
        //   })
        //   .catch(e => {});

        return;
      },
      get() {
        let o = [];
        if (this.$route.query.timerange_from) {
          o.push(this.$route.query.timerange_from);
          if (this.$route.query.timerange_to)
            o.push(this.$route.query.timerange_to);
        }
        // _log_("read route ", o);
        return o.length ? o :  [moment().startOf('week').format("DD/MM/YYYY"), moment().endOf('year').format('DD/MM/YYYY')];
      }
    },
    wVehicleGroup: {
      set(v) {
        if (this.$route.params.vehicleGroup != v)
          this.routeGo({params: {vehicleGroup: v || 'all'}});
        // this.$router.replace({ params: { vehicleGroup: v } });
      },
      get() {
        return this.$route.params.vehicleGroup;
      }
    },
    servicesQuery() {
      if (!this.timelineRange) return;
      // _log_(
      //     "hel this.timelineRange[0] && this.timelineRange[1]",
      //     this.timelineRange[0],
      //     this.timelineRange[1]
      // );
      if (
          this.timelineRange[0] &&
          this.timelineRange[1] &&
          this.timelineRange[1] != "Invalid date" &&
          this.timelineRange[0] != "Invalid date"
      ) {
        const q = {
          _focusOn: this.focusOn,
          searchBkRoute: this.searchBkRoute,
          // ...this.$route.params,
          timerange_from: this.timelineRange[0],
          timerange_to: this.timelineRange[1],
          // ...this.$route.query,
          for: "rental",
          vehicleGroup: this.wVehicleGroup,
          with: "Vehicle",
          incluedCanceled: this.incluedCanceled,
          order: "date,startTimeMM,endTimeMM",
          limit: 0
        };
        return q;
      }
      return;
    }
  }
};
</script>

<style>
.routes .vis-item-content {
  height: 20px;

  overflow: hidden;
  font-size: 11px;
}

.routes .vis-item .vis-item-content {
  padding: 0px;
}

.routes .vis-item-content .material-icons {
  font-size: 12px;
}

.payments-done {
  padding-right: 3px;

  background-color: rgba(170, 255, 0, 0.49);
}

.payments-none {
  padding-right: 3px;
  background-color: rgba(255, 0, 0, 0.49);
  //border: 1px dashed red;
}

.payments-some {
  padding-right: 3px;
  background-color: rgba(245, 197, 77, 0.53);
}

.payments-un {
  padding-right: 3px;
  border: 2px solid red;
}
</style>
